import {getWidgetId, handleOptionUrl, replaceErrors} from "./utils/common";
import {
    execElementScripts,
    execScripts,
    ajaxLoadStylesheet,
    elementLoadStylesheet,
} from "./import-html-entry";
import { initShareUtils, shareUtilsGlobal } from "./globalUtils";
import { initShareLibs } from "./globalLibs";
import { initShareStyles } from "./globalStyles";
import { vueEntryMap } from "./index"
import MixinExpose from '@pa/widget-mixins-exposure/lib-umd'
const loaderVersion = require('../package.json').version;

// PAWidgetLoader.prefetch 入口
export function _prefetch(options) {
    options = options || {options};
    options.widgetNames = options.widgetNames || [];
    let loadPromise = [];
    options.widgetNames.forEach(widgetPath => {
        if (!vueEntryMap[widgetPath]) {
            let opts = handleOptionUrl({...options, widgetPath: widgetPath});
            loadPromise.push(injectStyle(opts.style, opts));
            loadPromise.push(injectScript(opts.script, opts));
        }
    });

    // 添加共享方法 promise
    loadPromise.push(_loadDependency(options.depends, options));

    return Promise.all(loadPromise).catch((e)=> {
        console.error("[widget-loader]: prefetch error");
        console.error(e);
    });
}

// PAWidgetLoader.loadPAComponent API入口
export function _loadPAComponent(options) {
    if(options) {
        let p = undefined;
        if(Object.prototype.toString.call(options) === '[object Array]') {
            p = Promise.all(options.map(opt => {
                // 处理离线/在线地址
                opt = handleOptionUrl(opt);
                return _loadComponent(opt);
            }));
        } else {
            // 处理离线/在线地址
            options = handleOptionUrl(options);
            p = Promise.all([_loadComponent(options)]);
        }
        return p
    } else {
        return Promise.resolve([]);
    }
}

function _loadComponent(options) {
    let p = new Promise(resolve => {
        let res = {
            id:options.id,
            options:options,
            component: doLoadComponent(options)
        }
        resolve(res);
    });
    return p;
}


export function _loadDependency (depends, options) {

    let loadSharePromise = [];
    // 加载共享方法组件
    if(typeof depends?.shareUtils === 'object' && Object.keys(depends.shareUtils).length > 0) {
        loadSharePromise.push(initShareUtils(depends.shareUtils, options));
    }
    // 加载共享库
    if(typeof depends?.shareLibs === 'object' && Object.keys(depends.shareLibs).length > 0) {
        loadSharePromise.push(initShareLibs(depends.shareLibs, options));
    }
    // 加载共享样式组件
    if(typeof depends?.shareStyles === 'object' && Object.keys(depends.shareStyles).length > 0) {
        loadSharePromise.push(initShareStyles(depends.shareStyles, options));
    }
    return loadSharePromise;
}

async function doLoadComponent(options) {
    // 先加载组件style，完成后再执行组件JS
    const moduleEntry = await injectStyleScript(options);

    if (moduleEntry?.depends) {
        await Promise.all(_loadDependency(moduleEntry?.depends, options));
    }

    let Component = Vue.extend({
        extends: moduleEntry?.default,
        mixins: [MixinExpose, {
            beforeCreate() {
                this.$loaderVm = this.$root;
                this.$loaderVm.shareUtils = shareUtilsGlobal;
            }
        }]
    });

    return new Promise(resolve => {
        let instanceProps = Object.assign({}, options.props);
        let instance = new Vue({
            mounted(){
                this.$children[0].$updateProps = function (props) {
                    instanceProps = Object.assign(instanceProps, props);
                    instance.$forceUpdate();
                    return instanceProps
                }
                // 组件渲染完成再调用resolve
                resolve(this.$children[0]);
            },
            render(h) {
                return h(Component, {
                    attrs: {
                        id: options.id,
                        ...options.attrs
                    },
                    props: {
                        ...instanceProps
                    },
                    on: {
                        ...options.on
                    }
                })
            }
        }).$mount(options.el)
    })

}

export async function injectStyleScript(options) {

    // 先加载器 css，
    let widgetId = getWidgetId(options.style);
    let start = Date.now();
    await injectStyle(options.style, options).catch(err => {
        window?._tag?.trackEvent?.(widgetId, '组件超市加载器css',
            {
                'WT.param': JSON.stringify({
                    errorMsg: JSON.stringify(err, replaceErrors),
                    loaderVersion: loaderVersion
                })
            });
    });
    let end = Date.now();
    let seconds = (end - start) / 1000;
    window?._tag?.trackEvent?.(widgetId, '组件超市加载器css',
        {
            duration: seconds,
            'WT.param': JSON.stringify({
                loaderVersion: loaderVersion
            })});

    // 加载JS
    widgetId = getWidgetId(options.script);
    start = Date.now();
    let entry = await injectScript(options.script, options).catch(err => {
        window?._tag?.trackEvent?.(widgetId, '组件超市加载器',
            {
                'WT.param': JSON.stringify({
                    errorMsg: JSON.stringify(err, replaceErrors),
                    loaderVersion: loaderVersion
                })
            });
    });
    end = Date.now();
    seconds = (end - start) / 1000;
    window?._tag?.trackEvent?.(widgetId, '组件超市加载器',
        {
            duration: seconds,
            'WT.param': JSON.stringify({
                loaderVersion: loaderVersion
            })
        });
    return entry
}

export async function injectScript(src, options) {
    if (options.offline === true || options.fetchType === 'elementLoad') {
        return execElementScripts(src)
    } else {
        return execScripts(src, null, options)
    }
}


export function injectStyle(src, options) {
    if (src && typeof src === 'string' && (options.offline === true || options.fetchType === 'elementLoad')) {
        return elementLoadStylesheet(src)
    } else if (src && typeof src === 'string') {
        return _doLoadStyle(src, options)
    } else {
        return Promise.resolve();
    }
}


function _doLoadStyle (src, options) {

    return ajaxLoadStylesheet(src, options).then((styleResp => {
        const style = document.createElement('style');
        // 判断是否存在options.styleContentRouter方法（用于处理组件内容）
        style.innerHTML = options.styleContentRouter ? options.styleContentRouter(styleResp, src, options) : styleResp;
        document.head.appendChild(style);
    }))
}